import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IStream } from '../stream.interface';
import { streamStoreSelector } from '../stream.selector';

export const streamSelector = createCachedSelector(
  [
    path(streamStoreSelector).data(),
    prop<{ streamId: IStream['streamId'] }>().streamId(),
  ],
  (data, streamId) => {
    return data[streamId];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ streamId: IStream['streamId'] }>().streamId(),
});
